import Head from './Head';
import Body from './Body';
import * as React from 'react';
import { observer } from 'mobx-react';
import { ParticipantImportFileRow } from '../../Store/Types';

interface Props {
  participants: ParticipantImportFileRow[];
}

const Table: React.FC<Props> = ({ participants }) => (
  <table className="min-w-full divide-y divide-gray-300 ">
    <Head />
    <Body participants={participants} />
  </table>
);

export default observer(Table);
